import { useEffect } from "react";
import { throttle } from "../../../lib/utils";

export function useScrollPagination({
  fetchNextPage,
  isFetchingNextPage,
}: {
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
}) {
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.getElementById("footer");
      if (!footer) return;

      const footerTop = footer.getBoundingClientRect().top;
      const viewportHeight = window.innerHeight;

      const isReachFooter =
        footerTop <= viewportHeight &&
        footerTop <= viewportHeight + 100;

      if (isReachFooter && !isFetchingNextPage) {
        fetchNextPage();
      }
    };

    const throttledHandleScroll = throttle(
      handleScroll,
      300
    );
    window.addEventListener(
      "scroll",
      throttledHandleScroll
    );
    return () =>
      window.removeEventListener(
        "scroll",
        throttledHandleScroll
      );
  }, [fetchNextPage, isFetchingNextPage]);
}
